/**
 * Environment Indicator Boot — UI app
 *
 * Overlays a colored favicon badge for non-production environments.
 * Implementation lives in `@shared/vue/utils/environmentIndicator`; this file
 * just wires it into the Quasar boot flow. The environment name in the tab
 * title is handled by the shared title formatter (`formatDocumentTitle`).
 */

import { defineBoot } from '#q-app';
import { useEnvironmentConfig } from '@shared/vue/composables';
import { installEnvironmentIndicator } from '@shared/vue/utils/environmentIndicator';

export default defineBoot(() => {
  installEnvironmentIndicator({ env: useEnvironmentConfig() });
});
